import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const formats = [
  "DD MMM YYYY HH:mm:ss [UTC]",
  "YYYY-MM-DD HH:mm:ss [UTC]",
  "YYYY-MM-DDTHH:mm:ssZ",
  "YYYY-MM-DDTHH:mm:ss.SSSSSSZ",
  "YYYY-MM-DD HH:mm:ss.SSS"
];

// Currently our backend have multiple date formats, some of them are not parseable by safari/gecko
export const parseDate = (date: Date | string | number): Date => {
  if (date instanceof Date) {
    return date;
  }

  // Evaluate each format using dayjs
  for (const format of formats) {
    const d = dayjs.utc(date, format, true);
    if (d.isValid()) {
      return d.toDate();
    }
  }

  return new Date(date);
};
